import React from 'react'
import styles from './MetrixVisual.module.scss'

const launches = [2, 3, 3, 5, 6, 8, 12]

const ventures = [
  { initials: 'RO', name: 'Retail OS', sector: 'Retail Intelligence', stage: 'Scaling', progress: 90, tone: 'live' },
  { initials: 'QC', name: 'QuickCart', sector: 'Quick Commerce', stage: 'MVP', progress: 62, tone: 'build' },
  { initials: 'DL', name: 'DataLake AI', sector: 'AI / LLM', stage: 'Seed', progress: 38, tone: 'seed' },
]

const MetrixVisual = () => {
  return (
    <div className={styles['dashboard']} aria-hidden='true'>
      <div className={styles['window-bar']}>
        <span className={styles['dot']} />
        <span className={styles['dot']} />
        <span className={styles['dot']} />
        <span className={styles['url']}>studio.socommerz.com</span>
      </div>

      <div className={styles['body']}>
        <div className={styles['revenue-row']}>
          <div>
            <p className={styles['label']}>Active ventures</p>
            <p className={styles['amount']}>12</p>
          </div>
          <span className={styles['delta']}>
            <svg viewBox='0 0 12 12' width='12' height='12' fill='none'>
              <path d='M6 2v8M6 2l3 3M6 2L3 5' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
            +4 this year
          </span>
        </div>

        <div className={styles['chart-head']}>Ventures launched</div>
        <div className={styles['chart']}>
          {launches.map((height, index) => (
            <span
              key={index}
              className={styles['bar']}
              style={{ height: `${(height / 12) * 100}%`, animationDelay: `${index * 0.12}s` }}
            />
          ))}
        </div>

        <div className={styles['orders']}>
          <div className={styles['orders-head']}>
            <span>Portfolio</span>
            <span className={styles['live']}>
              <i className={styles['live-dot']} />
              Live
            </span>
          </div>

          {ventures.map((v, index) => (
            <div
              key={v.initials}
              className={styles['venture']}
              style={{ animationDelay: `${0.4 + index * 0.18}s` }}
            >
              <div className={styles['venture-top']}>
                <span className={styles['avatar']}>{v.initials}</span>
                <div className={styles['order-info']}>
                  <p className={styles['order-name']}>{v.name}</p>
                  <p className={styles['order-item']}>{v.sector}</p>
                </div>
                <span className={`${styles['pill']} ${styles[`pill-${v.tone}`]}`}>
                  {v.stage}
                </span>
              </div>
              <div className={styles['progress']}>
                <span
                  className={styles['progress-fill']}
                  style={{ width: `${v.progress}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles['toast']}>
        <span className={styles['toast-icon']}>
          <svg viewBox='0 0 16 16' width='14' height='14' fill='none'>
            <path d='M3.5 8.5l3 3 6-7' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
        </span>
        New venture onboarded
      </div>
    </div>
  )
}

export default MetrixVisual
